import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `
  <h2>Privacy Policy</h2>
  <p>At St. Andrews World School, we are committed to protecting the privacy of our students, parents, staff, and website visitors. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our website or interact with us.</p>
  <h2>Information We Collect</h2>
  <p>We may collect personal information such as name, email address, phone number, postal address, and other relevant details when you fill out forms on our website, register your child for admission, or communicate with us. We also collect non-personal information such as browser type, operating system, and browsing behavior through cookies and analytics tools.</p>
  <h2>How We Use Your Information</h2>
  <p>The information we collect is used to process admissions, respond to inquiries, improve our website and services, send important updates and announcements, and comply with legal obligations. We do not sell, trade, or rent your personal information to third parties.</p>
  <h2>Data Security</h2>
  <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.</p>
  <h2>Cookies</h2>
  <p>Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can choose to disable cookies through your browser settings, but this may affect certain features of the website.</p>
  <h2>Third-Party Links</h2>
  <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.</p>
  <h2>Children's Privacy</h2>
  <p>We are committed to protecting the privacy of children. We do not knowingly collect personal information from children under the age of 13 without parental consent. If you believe we have inadvertently collected such information, please contact us to have it removed.</p>
  <h2>Changes to This Policy</h2>
  <p>We reserve the right to update this Privacy Policy at any time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.</p>
  <h2>Contact Us</h2>
  <p>If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:info@standrewsworldschool.com">info@standrewsworldschool.com</a> or call us at <a href="tel:+919311668860">+91-9311668860</a> or <a href="tel:+919311668861">+91-9311668861</a>.</p>
`;

const PrivacyPolicy = () => {
  const pageData = usePage('privacy-policy', { content: DEFAULT_CONTENT });

  const title = 'Privacy Policy';

  return (
    <>
      <SEO
        slug="privacy-policy"
        title={title} description="Privacy Policy of St. Andrews World School, Indirapuram. Learn about how we collect, use, and protect your personal information." keywords="Privacy Policy, St. Andrews Indirapuram" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/why-choose-us.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner"></div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed space-y-5" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
